import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { GroupsService } from '../groups.service';
import { Group } from '../../../shared/models/interfaces';
import { AuthService } from '../../../core/auth/auth.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DATE_FORMATS } from 'src/app/shared/constants/date-formats';

@Component({
  selector: 'mmp-groups-overview',
  templateUrl: './groups-overview.component.html',
  styleUrls: ['./groups-overview.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    UIComponentsModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }],
})
export class GroupsOverviewComponent implements OnInit {
  displayedColumns: string[] = [
    'groupName',
    'trackingPeriod',
    'numberOfStudents',
    'status',
  ];
  dataSource = new MatTableDataSource<Group>();
  selectedGroup: Group | undefined;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public groupsService: GroupsService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.groupsService.getGroupsForUser().subscribe((groups) => {
      this.dataSource.data = groups;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  openGroupDetailView(group: Group) {
    if (!group.id) {
      console.error('Group ID is missing or invalid:', group);
      return;
    }
    this.groupsService.setSelectedGroup(group);
    this.router.navigate(['/group', group.id]);
  }
}
